// Nombre con el que se muestra a un jugador en los partidos: su alias si lo
// tiene y, si no, el nombre completo. El catálogo, el ranking de jugadores y
// los editores siguen usando `nombre` (el completo).
export const nombreVisible = (jugador) => {
  const alias = jugador?.alias?.trim();
  return alias || jugador?.nombre || '';
};
